import { Link } from "react-router-dom";

import CloseIcon from "@material-ui/icons/Close";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LiveTvIcon from "@material-ui/icons/LiveTv";
import MenuIcon from "@material-ui/icons/Menu";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import styled from "styled-components";

interface PropsMenu {
  isOpen: boolean;
}

export const Container = styled.div`
  background-color: #1d1e1c;
  width: 100%;
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: space-evenly;
  margin: auto;
  @media (max-width: 768px) {
    height: 50px;
  }
`;

export const ContainerBanner = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`;

/** LOGO */

export const ContainerLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #1d1e1c;
  width: 100%;
  max-width: 80px;
  height: 100px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImgLogo = styled.img`
  width: 100px;
  height: 100px;
  margin-left: 0px;
`;

/** MENU */

export const ContainerMainMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  /* background-color: yellow; */
  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }
`;

export const ContainerMenu = styled.div`
  position: ${(props: PropsMenu) => (props.isOpen ? "absolute" : "relative")};
  width: ${(props: PropsMenu) => (props.isOpen ? "50vw" : "")};
  height: ${(props: PropsMenu) => (props.isOpen ? "100vw" : "")};
  z-index: ${(props: PropsMenu) => (props.isOpen ? "10" : "0")};
  top: ${(props: PropsMenu) => (props.isOpen ? "0" : "")};
  left: ${(props: PropsMenu) => (props.isOpen ? "0" : "")};
  background-color: ${(props: PropsMenu) => (props.isOpen ? "#1d1e1c" : "")};
`;

export const Menu = styled.nav`
  background-color: #1d1e1c;
  z-index: 30;
  /* background-color: red; */
  display: flex;
  overflow: hidden;
  /* align-items: flex-end; */
  /* justify-content: flex-end; */
  margin-top: 10px;
  @media (max-width: 768px) {
    display: ${(props: PropsMenu) => (props.isOpen ? "flex" : "none")};
  }
`;

export const SectionMenu = styled.ul`
  /* background-color: yellow; */
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: ${(props: PropsMenu) =>
    props.isOpen ? "calc(10px + 1vw)" : "calc(2px + 1vw)"};
  flex-direction: ${(props: PropsMenu) => (props.isOpen ? "column" : "row")};
`;

export const ItemMenu = styled.li`
  list-style: none;
  margin: ${(props: PropsMenu) => (props.isOpen ? "10px" : "0")};
`;

export const ItemMenuLogo = styled.li`
  list-style: none;
  margin: ${(props: PropsMenu) => (props.isOpen ? "10px" : "1px")};
  display: ${(props: PropsMenu) => (props.isOpen ? "flex" : "none")};
`;

export const LinkMenu = styled(Link).attrs((props) => ({}))`
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  padding: 15px;
  transition: all 250ms linear 0s;
  @media (max-width: 1440px) {
    padding: 8px;
  }
  @media (max-width: 2560px) {
    padding: 8px;
  }
`;

export const LinkSale = styled(Link).attrs((props) => ({}))`
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 250ms linear 0s;
`;

export const MenuTogle = styled.div`
  background-color: #1d1e1c;
  display: none;
  flex-grow: 1;
  width: 60px;
  height: 60px;
  margin-left: 10px;
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ContainerIconMenu = styled.div`
  display: ${(props: PropsMenu) => (props.isOpen ? "none" : "flex")};
  /* display: flex; */
  align-items: center;
`;

export const ContainerIconCloseMenu = styled.div`
  display: ${(props: PropsMenu) => (props.isOpen ? "flex" : "none")};
  /* display: flex; */
  align-items: center;
`;

export const IconMenu = styled(MenuIcon)`
  color: white;
  font-size: 30px !important;
`;

export const IconCloseMenu = styled(CloseIcon)`
  color: white;
  font-size: 30px !important;
`;

/**
 * Container midias
 */

export const ContainerMidias = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  /* margin-right: 20px; */
  /* margin-bottom: 25px; */
  @media (max-width: 768px) {
    width: 150px;
    justify-content: space-between;
    margin-right: 10px;
    height: 100%;
  }
`;

export const ImgInstagram = styled(InstagramIcon)`
  color: #3f729b;
  margin-left: 10px;
  margin-top: 10px;
  &:hover {
    color: #999;
    cursor: pointer;
    zoom: 1;
  }
`;

export const ImgFacebook = styled(FacebookIcon)`
  color: #3b5998;
  margin-left: 10px;
  &:hover {
    color: #999;
    cursor: pointer;
    zoom: 1;
  }
`;

export const ImgVideo = styled(LiveTvIcon)`
  margin-left: 10px;
  color: white;
  &:hover {
    color: #999;
    cursor: pointer;
    zoom: 1;
  }
`;

export const ImgSale = styled(MonetizationOnIcon)`
  margin-left: 10px;
  color: red;
  &:hover {
    color: #999;
    cursor: pointer;
    zoom: 1;
  }
`;
